module.exports = __webpack_public_path__ + "img/logo@2x.9555b0cf.png";